import { Button, Icon, VerticalDivider } from '@smartgift/frontend-toolkit';
import React, { useState, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { NewShareTemplate } from '@hero/components';
import { ShareTable } from '@hero/organisms';
import { useGetRecognition, useGetRecognitionOrders } from '@hero/services/order-service';

import * as S from './style';

export function RecognitionShareTemplate({ onClickSendReminder, contactType }) {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const [globalFilters, setGlobalFilters] = useState({});
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10
  });
  const { data: recognition } = useGetRecognition({ recognitionCode });

  const params = useMemo(
    () => ({
      filters: {
        searchTerm: globalFilters?.searchTerms,
        giftStatus: globalFilters?.filters?.map(filter => filter.value),
        recognitionId: recognition?.id
      },
      pagination: {
        limit: pageSize,
        page: pageIndex + 1
      }
    }),
    [pageSize, pageIndex, recognition?.id, globalFilters]
  );
  const {
    data: recipientsData,
    isFetching: isLoadingRecipients,
    refetch: refetchRecipients
  } = useGetRecognitionOrders(params, {
    retryOnMount: false,
    enabled: !!recognition?.id
  });

  const isReminderActive = useMemo(() => {
    const totalRecipients = recognition?.acceptanceRates?.total;
    const totalAcceptedRecipients = recognition?.acceptanceRates?.accepted;

    if (totalRecipients === 0) return false;
    if (totalAcceptedRecipients === 0) return true;

    return totalRecipients - totalAcceptedRecipients > 0;
  }, [recognition]);

  const shareType = recognition?.contacts?.type === 'list' ? 'table' : 'share';

  return (
    <>
      {contactType === 'list' && (
        <S.ShareHeader>
          <S.ShareHeaderLeft>
            <>
              <S.ShareHeaderText>
                <Trans
                  i18nKey="totalRecipients"
                  values={{ count: recipientsData?.totalDocs || 0 }}
                  components={{ b: <b /> }}
                />
              </S.ShareHeaderText>
              {isReminderActive && (
                <>
                  <VerticalDivider $margin="0 16px" $height="24px" />
                  <Button variant="link" onClick={onClickSendReminder}>
                    <Icon name="email" color="var(--color-accent-primary-default)" />
                    {t('remindRecipients')}
                  </Button>
                </>
              )}
            </>
          </S.ShareHeaderLeft>
        </S.ShareHeader>
      )}
      {shareType === 'table' ? (
        <ShareTable
          data={recipientsData?.docs}
          globalFilters={globalFilters}
          setGlobalFilters={setGlobalFilters}
          pagination={{
            pageIndex,
            pageSize,
            total: recipientsData?.totalDocs
          }}
          isLoading={isLoadingRecipients}
          pageCount={recipientsData?.totalPages}
          setPagination={setPagination}
          refetchRecognition={refetchRecipients}
        />
      ) : (
        <NewShareTemplate
          recipientCount={recognition?.contacts?.maxCount}
          featureType="recognition"
          secureSingleLink={recognition?.link?.shortened}
        />
      )}
    </>
  );
}
